export function getFeatureFlags() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        enablePremiumDigital: !urlParams.has('disableDigitalPlus'),
        enableDigitalAccess: urlParams.has('enableDigitalAccess'),
    };
}
